import { render, staticRenderFns } from "./LpuCardsSection.vue?vue&type=template&id=8c4ad92e&scoped=true&"
import script from "./LpuCardsSection.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LpuCardsSection.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LpuCardsSection.vue?vue&type=style&index=0&id=8c4ad92e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4ad92e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c4ad92e')) {
      api.createRecord('8c4ad92e', component.options)
    } else {
      api.reload('8c4ad92e', component.options)
    }
    module.hot.accept("./LpuCardsSection.vue?vue&type=template&id=8c4ad92e&scoped=true&", function () {
      api.rerender('8c4ad92e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/LpuCard/LpuCardsSection.vue"
export default component.exports